export default "__VITE_PUBLIC_ASSET__bd372dd9__"